import { TableConfig } from '@shared/interfaces/table/table-config';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { ChargeInformationDto } from '@app/api/dmc';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { existsInDatahub } from '@shared/partials/existsindatahub.partial';

export const chargeinformationTable: TableConfig<ChargeInformationDto> = {
  id: 'chargeinformation-list',
  title: 'chargeInformation.title',
  exportable: true,
  copyable: true,
  floatingHeader: true,
  selectable: true,
  selectableType: 'single',
  saveChanges: true,
  pageSize: 25,
  pageSizeSelection: true,
  columns: [
    {
      title: 'chargeInformation.chargeType',
      key: 'chargeType',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        notspecified: 'chargeInformation.chargeTypes.notspecified',
        subscription: 'chargeInformation.chargeTypes.subscription',
        fee: 'chargeInformation.chargeTypes.fee',
        tariff: 'chargeInformation.chargeTypes.tariff'
      }
    },
    {
      title: 'chargeInformation.chargeTypeId',
      key: 'chargeTypeId',
      width: 175,
      cellRenderer: LinkCellComponent,
      cellRendererParams: {
        url: '/chargeinformation',
        urlReference: 'chargeInformationDeltaId',
      }
    },
    {
      title: 'chargeInformation.description',
      key: 'description'
    },
    {
      title: 'chargeInformation.longDescription',
      key: 'longDescription'
    },
    {
      title: 'chargeInformation.observationPeriod',
      key: 'observationPeriod',
      cellRenderer: TranslateCellComponent,
      cellRendererParams: {
        notspecified: 'chargeInformation.observationPeriods.notSpecified',
        hour: 'chargeInformation.observationPeriods.hour',
        quarter: 'chargeInformation.observationPeriods.quarter',
        day: 'chargeInformation.observationPeriods.day',
        month: 'chargeInformation.observationPeriods.month',
        year: 'chargeInformation.observationPeriods.year',
        other: 'chargeInformation.observationPeriods.other'
      }
    },
    {
      title: 'chargeInformation.ownerEnergyPartyName',
      key: 'ownerEnergyPartyName'
    },
    {
      title: 'chargeInformation.chargePriceValidTo',
      key: 'chargePriceValidTo',
      cellRenderer: DateCellComponent,
    },
    datahubPartial,
    existsInDatahub
  ]
}
